import { createContext, useContext } from 'react';

/**
 * The current batch's (or experiment's) resolved destination name ("Google Merchant Center"), so
 * `useRunLabels().stageLabel` can read DELIVERY as "Publish to <destination>" everywhere under a
 * batch without every nested component re-deriving or prop-drilling the connector. Provided once
 * by `RunShell` and the experiment detail page (the same value their own headers compute from
 * `connectorCode`); `null` outside either, where the plain "Publish" is correct (e.g. a runs list
 * or schedules screen spanning many batches with different destinations).
 */
export const StageDestinationCtx = createContext<string | null>(null);

/** Reads the ambient destination name; `null` with no provider above, or no destination known yet. */
export function useStageDestination(): string | null {
  return useContext(StageDestinationCtx);
}
